import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import favorites_gen_2 from '@devices/settings/device_settings/favorites_gen_2.js';
import safety_cover_gen_2 from '@devices/settings/device_settings/safety_cover_gen_2.js';
import roller_app_setting_gen_2 from '@devices/settings/device_settings/roller_app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import pro_dual_cover_settings_gen_2 from '@devices/settings/device_settings/pro_dual_cover_settings_gen_2';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';

export default {
	name: 'ShellyPro2Cover',
	friendly_name: 'Pro Dual Cover',
	family: 'roller',
	isPM: true,
	gen: 2,
	reset_from_input: false,
	modes: {
		roller: {
			channels: 2,
			notifications: ['offline', 'device_problem', 'overpower', 'overtemperature'],
			slider: true,
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				virtual_components_pro_devices,
				networks_gen_2_pro,
				bluetooth_bt_home_control_gen_2,
				favorites_gen_2,
				safety_cover_gen_2,
				roller_app_setting_gen_2,
				share,
				pro_dual_cover_settings_gen_2,
			],
		},
	},
};
